import {alpha} from '@mui/material';

import {DefaultThemeOptions} from 'config/theme';

const theme = DefaultThemeOptions;

export const defaultModalStyle: any = {
  '& .MuiPaper-root': {
    borderRadius: '8px',
    boxShadow: 2
  },
  '.css-yiavyu-MuiBackdrop-root-MuiDialog-backdrop': {
    backgroundColor: alpha(theme.palette.grey[900], 0.2)
  }
};
